module.exports = __webpack_public_path__ + "img/loading.b58b665a.svg";